// extracted by mini-css-extract-plugin
export default {"App":"app_App__s6hGw","Sidebar":"app_Sidebar__ffTaL","Content":"app_Content__Gprww","Body":"app_Body__7IJuI","Main":"app_Main__MmrMP","NotFound":"app_NotFound__Z2i63"};